import type { FaireProductEntity } from "../../entity_types/product";

export const p_5nut65sesg: FaireProductEntity = {
  token: "p_5nut65sesg",
  type: "product",
  name: "Timeless Beauty - Whipped Facial Tallow Balm | TOP SELLER",
  brandToken: "b_97fwzxfjvs",
  brandName: "Simply Happy",
  imageUrl:
    "https://cdn.faire.com/fastly/1dd4dbaaeb513277b70a84930c5b2b655e38017f56bfa8eb343f6a3e6a92f434.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/2790ef3f77ffc8d7a49ccfbaa60087c2a9e6ebbee4e9f1d68cc28b19dfdbc31b.jpeg",
    "https://cdn.faire.com/fastly/2cb270a37ce2c933b167f1ac00a56a777a9b06829e06ba51677c021114ad962c.jpeg",
    "https://cdn.faire.com/fastly/0c117d701bebdba2daf72b6e78683f78aae81103324e7d74c3e8dd6bb1fa7c7e.jpeg",
    "https://cdn.faire.com/fastly/0ceec95f9f74394e9705e96ee521921cbd381e17bc8ab2bbc2ccfe9347e19d31.jpeg",
    "https://cdn.faire.com/fastly/c910381a92c2abdc5aeb604344ef8cb322b187c3acddb4a19dc86d7a94f85ab0.jpeg",
    "https://cdn.faire.com/fastly/9c28f1e0e7c5aa9b7c74ff33a2e4043073f9ff967e8308765d9cbcd67458c062.jpeg",
    "https://cdn.faire.com/fastly/1da9d13ef0ecb5bc657784d61facb4b46fee424895ee43ec72d19340bc4c5fcf.jpeg",
  ],
  priceDollars: 22.17,
  description:
    "OUR TOP SELLER | Grass-Fed & Finished | Clean, Radiant Skincare\n\nGive your customers the luxurious, all-natural facial care they deserve with Simply Happy’s Timeless Beauty Whipped Tallow Balm with Rosehip Oil—our best-selling blend crafted with 100% grass-fed and finished tallow from Minnesota.\n\nWhipped to a silky, lightweight texture and enriched with rosehip oil, this balm is perfect for women’s daily facial skincare. It nourishes deeply, helps support radiant, youthful-looking skin, and is completely free from toxins, parabens, sulfates, and chemicals.\n\nCustomers love its clean, timeless formula—gentle, effective, and safe for all skin types. Retailers love its proven demand, small-batch quality, and loyal customer following. A year-round best-seller, this balm shines in clean beauty displays and women’s skincare sections.\n\nJars are 2oz.",
  tags: [],
  msrpDollars: 44.34,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:01:19.774Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
